export const ARADO_SUBSOLADOR_DISCO_CORTE = {
    Codigo: 2,
    Nome: 'Arado Subsolador c/ Disco de Corte',
    Modelo: 'GIR-1300',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Size: "auto 50%", 
            Url: "assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/arado_disco_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/arado_disco_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/arado_disco_3.png"
        }
        , {
            Url: "assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/arado_disco_4.png"
        }
        , {
            Url: "assets/IPB/Produtos/Arado_Subsolador_DiscoCorte/arado_disco_5.png"
        }
    ],
    Detalhes: [
        `Disco de corte frontal e rodas de profundidade`,
        `Largura de corte: 1,70m (pesado)`,
        `Largura de corte: 1,90m (pesado)`,
        `Profundidade de penetração no solo: 300mm`,
        `Opcionais: `,
        `- Jogo de rodas para regulagem de profundidade e rolo destorrador.` ,
        `- Garra fixa com pino fusível` ,
        `- Garra regulável com parafuso`
    ],
    Modelos: [
        { Modelo: 'ASD-5F', Detalhes: '5 ferros' },
        { Modelo: 'ASD-7F', Detalhes: '7 ferros' },
    ]
}